import * as React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { closeConfirmModal, setActiveCard } from "../../redux/create-actions/ConfirmAction"
import { Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import { showAlert } from '../../redux/create-actions/AlertAction';
import Color from '../Color';
import { Check, Close } from '@mui/icons-material';
import { graphActivateCard, setContractStatus, upgradePlasticCard } from '../../services/CardOperation';

const dialogAction = { pb: '20px' };
const buttonConfirm = {
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Main }
};

const buttonCancel = {
  color: Color.Button,
  backgroundColor: Color.Dangerous,
  '&:hover': { background: Color.Button, color: Color.Dangerous }
};

export default function ConfirmModal() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const data = useSelector(state => state.confirm.data);

  const handleConfirm = () => {

    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: ''
    };
    switch (data.feature) {
      case "UPGRADE_CARD":
        const data1 = {
          contractId: parseInt(data.contractId)
        }
        let upGradeCard = upgradePlasticCard(data1);
        upGradeCard.then(result => {
          alert = { ...alert, severity: 'info', title: "Info", message: result.data.RetMsg._text };
          dispatch(showAlert(alert));
          dispatch(setActiveCard())
          dispatch(closeConfirmModal());
        }).catch((error) => {
          const err = JSON.parse(JSON.stringify(error))
          alert = { ...alert, message: err.response.errors[0].message };
          dispatch(showAlert(alert));
          dispatch(closeConfirmModal());
        })
        break;
      case "ACTIVE_CARD":
        const data3 = {
          contractId: parseInt(data.contractId),
          newStatus: 'ACTIVE'
        }
        let activateCard = graphActivateCard(data3)
        activateCard.then((result) => {
          alert = { ...alert, severity: 'info', title: "Info", message: result.data.RetMsg._text };
          dispatch(closeConfirmModal());
          dispatch(setActiveCard());
          dispatch(showAlert(alert));
        }).catch(function (error) {
          const err = JSON.parse(JSON.stringify(error))
          alert = { ...alert, message: err.response.errors[0].message };
          dispatch(closeConfirmModal());
          dispatch(showAlert(alert));
        })
        break;
      case "LOCK_CARD":
        const data4 = {
          contractId: parseInt(data.contractId),
          newStatus: 'LOCK'
        }
        let lockCard = setContractStatus(data4)
        lockCard.then((result) => {
          alert = { ...alert, severity: 'info', title: "Info", message: result.data.RetMsg._text };
          dispatch(closeConfirmModal());
          dispatch(setActiveCard());
          dispatch(showAlert(alert));
        }).catch(function (error) {
          const err = JSON.parse(JSON.stringify(error))
          alert = { ...alert, message: err.response.errors[0].message };
          dispatch(closeConfirmModal());
          dispatch(showAlert(alert));
        })
        break;
      default:
        break;
    }
  }

  const handleClose = () => {
    dispatch(closeConfirmModal());
  };

  const renderConfirm = () => {
    return <>
      <DialogTitle id="responsive-dialog-title"
        sx={{
          pt: `${matchDownSM ? '24px' : '32px'}`,
          pl: `${matchDownSM ? '8px' : '12px'}`,
          pr: `${matchDownSM ? '8px' : '12px'}`,
          pb: `${matchDownSM ? '12px' : '12px'}`,
        }}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item sx={{ color: theme.typography.h3 }}>{data.title}</Grid>
        </Grid>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: '5px',
          pl: `${matchDownSM ? '10px' : '24px'}`,
          pr: `${matchDownSM ? '10px' : '24px'}`,
          pb: `${matchDownSM ? '8px' : '24px'}`,
          textAlign: 'center'
        }}>
        <DialogContentText sx={{ color: theme.typography.h4 }}>
          {data.message}
        </DialogContentText>
      </DialogContent>
    </>
  }
  return (
    <Container maxWidth="xs" >
      <Dialog
        open={data.isOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Grid sx={{ bgcolor: theme.palette.background.default }}>
          {renderConfirm(data.isOpen)}
          <DialogActions sx={dialogAction} >
            <Grid container align="center" justifyContent="center" columnGap={matchDownSM ? '20px' : '30px'}>
              <Grid item >
                <Button variant="contained" size={matchDownSM ? 'small' : 'medium'} sx={buttonCancel} onClick={handleClose} endIcon={<Close fontSize='small'></Close>}>
                  Cancel
                </Button>
              </Grid>
              <Grid item >
                <Button variant="contained" size={matchDownSM ? 'small' : 'medium'} sx={buttonConfirm} onClick={handleConfirm} endIcon={<Check fontSize='small'></Check>}>
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Grid>
      </Dialog>
    </Container>

  );
}